import React from "react";
import { Box, Stack } from "@mui/material";
import GoogleSignInButton from "../../common/GoogleSignInButton.tsx";
import EconomicSignInButton from "../../common/EconomicSignInButton.tsx";
import MicrosoftSignInButton from "../../common/MicrosoftSignInButton.tsx";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../hooks.tsx";
import { conversationActions } from "../../../store/conversation.tsx";
import handleSignUp from "./handleSignUp.tsx";

const SignUpOptions: React.FC = () => {
  const dispatch = useDispatch();
  const anonymousSession = useTypedSelector(
    (state) => state.authState.anonymousSession,
  );

  const handleClick = async (providerLabel: string) => {
    dispatch(
      conversationActions.appendCustomActionPrompt({
        text: providerLabel,
        type: "TextResponse",
      }),
    );

    await handleSignUp({
      searchText: providerLabel,
      dispatch,
      signUpState: anonymousSession?.signUpState,
    });
  };

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <GoogleSignInButton onClick={() => handleClick("Google")} />
        <EconomicSignInButton onClick={() => handleClick("Visma Connect")} />
        <MicrosoftSignInButton onClick={() => handleClick("Microsoft")} />
      </Stack>
    </Box>
  );
};

export default SignUpOptions;
